var AJAX = {
  _updateSubelements: function (post, $input) {
    // build the val
    $input.parent().find('.input-group-addon').html('<img src="/includes/images/ajax-loader.gif" height="14" width="14" />');
    var postData = encodeURIComponent( $input.attr('name') )+'='+$input.val();
    var jqxhr = $.ajax({
      type: 'post',
      url: APPLICATION._PATH_PREFIX+'comms/'+$input.attr('data-name'),
      data: post+'&'+postData
    }).done(function(data){
      AJAX._subElementComplete(data, $input)
    });
  },
  _subElementComplete: function(data, $el){
    if(data.status) {
      $el.parents('.input-group').find('.input-group-addon').html('<i class="fa fa-check" aria-hidden="true"></i>');
    }
    else {
      $el.parents('.input-group').find('.input-group-addon').html('<i class="fa fa-times" aria-hidden="true"></i>');
    }
  }
};
// Export
module.exports =
  {

    // Search scripts
    search:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.load($('#submissions'), APPLICATION._PATH_PREFIX + 'comms/submissions', 'Comms', 'submissions')
      }

    },

    submissions:
    {
      _init: function ()
      {
        APPLICATION._APPLICATION.processLinks('#submissions', 'Comms', 'submissions')

        // On click mail merge
        $('#mail-merge').not('.js-ignore').click(function ()
        {

          // The IDs
          var ids = []

          // Iterate over the checked IDs
          $('.js-signup_account_ids:checked').each(function ()
          {
            ids.push($(this).val())
          }
          )

          // If 1 or more
          if (ids.length > 0)
          {
            document.location.href = APPLICATION._PATH_PREFIX + 'comms/mail-merge?signup_account_ids=' + ids.join(',')
          }

        }
        ).addClass('js-ignore')

        $('.js-value').not('js-ignore').change(function ()
        {

          var id = $('.js-signup_account_ids', $(this).closest('tr')).val()

          var data = {}

          data[$(this).attr('name')] = $(this).val()

          $.post(APPLICATION._PATH_PREFIX + 'comms/update/' + id, data)

        }
        ).addClass('js-ignore')

        $('[data-type] > input[type="checkbox"]').not('js-ignore').each(function(){
          var $this = $(this);

          $this.on('change', function(){
            var $this = $(this);
            var status = $this.prop('checked') ? 1 : 0;
            // Build the post data
            var $parent = $this.parents('[data-type]');
            var type = $parent.attr('data-type');

            var val = $parent.find('input[type="checkbox"]').attr('name');
            var post = $parent.find('input[type="hidden"]').serialize();

            post += '&' + encodeURIComponent(val)+'='+status;

            // perofrm ajax call to update the database
            var jqxhr = $.ajax({
              type: 'post',
              url: APPLICATION._PATH_PREFIX+'comms/'+type,
              data: post
            })
              .done(function(data){
                if(status == 1) {
                  if(data.status) {
                    // find any child elements and convert them into inputs
                    $this.parents('tr').find('[data-parent="'+val+'"]').each(function(i, e){
                      var $e = $(e);

                      var $input = $("<input>", {
                        val: $e.text(),
                        type: "text",
                        name: $e.attr('data-name')
                      });
                      $e.replaceWith($input);
                      $input.wrap('<div class="input-group" />');
                      $input.attr('data-name', $input.attr('name'));
                      $input.parent().append('<span class="input-group-addon" data-name="'+$e.attr('data-name')+'"></span>');
                      // Should be event based?
                      if($input.attr('name') == 'imei') {
                        $input.attr('size', 20);
                        $input.attr('maxlength', 15);
                      }
                      $input.attr('data-parent', val);
                      $input.on('blur', function(){
                        console.log('BLUR');
                        AJAX._updateSubelements(post, $input);
                      });

                    });
                  }
                }
                else {
                  // remove boxes
                  $this.parents('tr').find('[data-parent="'+val+'"]').each(function(i, e){
                    var $span = $("<span>", {
                      text: $(e).val()
                    });
                    $span.attr('data-name', $(e).attr('data-name'));
                    $span.attr('data-parent', $(e).attr('data-parent'));
                    $(e).parent().replaceWith($span);
                  });
                }
              });

          });

        }).addClass('js-ignore');

        // On changing the company
        $('#company').not('.js-ignore').change(function ()
        {

          // Get the company ID
          var company_id = $(this).val()

          var phase = $('#site')

          APPLICATION._APPLICATION.loadDropdown(phase, APPLICATION._PATH_PREFIX + 'phase/all-dropdown/' + company_id + '?phase=' + phase.val(), 'Phase', 'allDropdown')

        }
        ).addClass('js-ignore')

        // set the events on default boxes
        $('[data-parent]').each(function(i, e){
          var $input = $(e);
          $input.on('blur', function () {
            // build the val
            $input.parent().find('.input-group-addon').html('<img src="/includes/images/ajax-loader.gif" height="14" width="14" />');
            var $parent = $('input[name="'+$input.attr('data-parent')+'"]');
            var post = $parent.parents('form').serialize();
            var postData = encodeURIComponent( $input.attr('name') )+'='+$input.val();
            var jqxhr = $.ajax({
              type: 'post',
              url: APPLICATION._PATH_PREFIX+'comms/'+$input.attr('data-name'),
              data: post+'&'+postData
            }).done(function(data){
              $input.parent().find('.input-group-addon').html('');
              AJAX._subElementComplete(data, $input)
            });
          });
        });
      }
    },
  // Select Plot scripts
  selectPlot:
  {

    // Method-wide scripts
    _init: function ()
    {

      // On changing the company
      $('#company_id').not('.js-ignore').change(function ()
      {

        // Get the company ID
        var company_id = $(this).val() || '0'

        if (company_id)
        {
          
        // Get the available developments
        var phase = $('#development_id')

        // Load the developments
          APPLICATION._APPLICATION.loadDropdown(phase, APPLICATION._PATH_PREFIX + 'phase/all-dropdown/' + company_id + '?phase=' + phase.val() + '&all=no', 'Phase', 'allDropdown')
        }
      }
      ).addClass('js-ignore').trigger('change')

      // On pressing continue
      $('#continue').not('.js-ignore').change(function ()
      {

        // Get the company ID
        var company_id = $(this).val() || '0'

        // Get the available developments
        var phase = $('#development_id')

       
      }
      ).addClass('js-ignore')
      
      $('#uploads').not('.js-ignore').change(function ()
      {

        var file_name = $('#file_name').val().split('.')

        var extension = file_name[file_name.length - 1]
        //console.log(['pdf','doc','docx'].indexOf(extension.toLowerCase()))
        if (['pdf','doc','docx'].indexOf(extension.toLowerCase()) == -1)
        {
          
          $('#file_name, #uploads').val('')

          $('#file_type_error').show().closest('.form-group').addClass('has-error')

        }

        else
        {
          $('#file_type_error').hide().closest('.form-group').removeClass('has-error')
        }

      }
      ).addClass('js-ignore')
      
    }

  }
}